import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar, InputAdornment } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Constant from '../../library/Constant'
import CustomTextField from '../components/customTextField'

export default function DetailKiosk(props) {
    const [nama, setNama] = useState("")
    const [lokasi, setLokasi] = useState("")
    const [url, setUrl] = useState("")
    const [listSubFacility, setListSubFacility] = useState([])
    const [listRoom, setListRoom] = useState([])
    const [subFasilitas, setSubFasilitas] = useState([])
    const [room, setRoom] = useState([])
    const [errorUrl, setErrorUrl] = React.useState(false);
    const [texterrorUrl, setTextErrorUrl] = React.useState(null);
    const [errorNama, setErrorNama] = React.useState(false);
    const [texterrorNama, setTextErrorNama] = React.useState(null);

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        api.create().getDetailKiosk(props.id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setNama(data.name)
                    let kioskDetail = []
                    data.kiosk_details.map((item) => {
                        kioskDetail.push({
                            id: item.sub_facilities.id,
                            nama: item.sub_facilities.name
                        })
                    })
                    setUrl(String(data.url).replace(`${Constant.URL_TEST}/medapp-kiosk/`, ""))
                    setSubFasilitas(kioskDetail)
                    getDataSubFasilitas()
                }
            }
        })
    }

    const getDataSubFasilitas = () => {
        api.create().getAllSubFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let listSubFacility = []
                    response.data.data.map((item) => {
                        if (item.status === 1) {
                            listSubFacility.push({
                                id: item.id,
                                nama: item.name
                            })
                        }
                    })
                    setListSubFacility(listSubFacility)
                    forceUpdate()
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        if (nama === "") {
            setErrorNama(true)
            setTextErrorNama("Nama wajib diisi")
        } else if (url === "") {
            setErrorUrl(true)
            setTextErrorUrl("URL wajib diisi")
        } else {
            let sub = []
            if (subFasilitas.length > 0) {
                subFasilitas.map((item) => {
                    sub.push(item.id)
                })
            }
            let payload = {
                "id": props.id,
                "name": nama,
                "url": url,
                "sub_facility_id": sub
            }
            props.updateKiosk(payload)
            // props.onClose()
        }
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Kiosk Display</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <CustomTextField
                                label="Nama Display"
                                placeholder={"input Nama Display"}
                                value={nama}
                                required={true}
                                error={errorNama}
                                helperText={texterrorNama}
                                onChange={(val) => {
                                    setNama(val)
                                    setErrorNama(false)
                                    setTextErrorNama("")
                                    forceUpdate()
                                }}
                            />
                        </div>

                        <Autocomplete
                            options={listSubFacility}
                            getOptionLabel={(option) => option.nama}
                            disableClearable
                            multiple
                            style={{ marginTop: 15 }}
                            name='subfasilitas'
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setSubFasilitas(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Sub Fasilitas"
                                />
                            }
                            value={subFasilitas}
                        />
                    </div>
                    <div className="column-2">

                        <div className="">
                            <TextField
                                style={{ width: '100%' }}
                                id="url"
                                name="url"
                                label="URL"
                                placeholder={"Input URL"}
                                required={true}
                                error={errorUrl}
                                helperText={texterrorUrl}
                                value={url}
                                onChange={(e) => {
                                    setUrl(e.target.value)
                                    setErrorUrl(false)
                                    setTextErrorUrl("")
                                    forceUpdate()
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="end" style={{ margin: 0, marginRight: 5 }}><span style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.54)' }}>medapp-kiosk/</span></InputAdornment>,
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
